import { useAppSelector } from "common/hooks/storeHooks";
import { formErrors } from "common/selectors/rsfForm.selectors";
import React from "react";
import dabellaLogo from "assets/images/dabella_logo.png";
import { Spinner } from "common/components/Spinner";
import { CustomLink } from "common/components/CustomLink";
import { Button } from "common/components/Button";

export interface OktaLoginProps {
  loading?: boolean;
}

export const DabellaLogin: React.FC<OktaLoginProps> = ({ loading }) => {
  const error = useAppSelector((state) => formErrors(state, { path: ["dabellaLogin"] })?.get("login"));
  const dvhSupported = CSS.supports("(height: 100dvh)");

  return (
    <div className={`w-screen ${dvhSupported ? "h-[100dvh]" : "h-screen"} flex justify-center items-center`}>
      <div className="flex flex-col items-center space-y-xl">
        <img src={dabellaLogo} alt={"Dabella Logo"} />

        <Spinner loadingSelector={() => Boolean(loading)} />

        {error && (
          <div className="space-flex flex-col items-center space-y-md">
            <div>
              <div className="text-red-600 text-center">{error}</div>
            </div>
            <CustomLink href="/dabella/login" className="flex justify-center">
              <Button analyticsAction="retry">Try Again</Button>
            </CustomLink>
          </div>
        )}
      </div>
    </div>
  );
};
